
import Advertisement from "@/components/Advertisement";
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import CheckBox from "@/components/main/core/CheckBox";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import BlogPost from "@/components/main/blog/BlogPost";
import RedSearchNow from "@/components/main/core/RedSearchNow";
import isMob576 from "@/mixins/isMob";
import CtaSteps from "@/components/main/steps/CtaSteps";

import 'epic-spinners/dist/lib/epic-spinners.min.css'
import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'
// const Paginate = process.client ? require('vuejs-paginate') : undefined
import Paginate from 'vuejs-paginate/src/components/Paginate.vue';
const StarRating = process.client ? require('vue-star-rating').default : undefined


export default {

  head() {
    const title = 'Exposing Cheating in Relationships - iFindCheaters Blog'
    const description = 'Explore insightful articles and advice on detecting cheating in relationships on dating, social media, and adult content sites. Learn how to protect yourself in relationships with iFindCheaters.';
    const ogTypeContent = 'article';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: ogTypeContent
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Online Cheating Detection, Relationship Safety, Dating Site Investigations, Social Media Background Checks, Mobile Chat App Scams, Background Check Services, find hidden dating profiles, verify spouse online, online infidelity search'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/blog/",
          href: this.$route.query.page === 1 ? 'https://ifindcheaters.com/blog/' : `https://ifindcheaters.com/blog/?page=${this.$route.query.page}`,
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
            }],
          }
        }
      ]
    }
  },
  name: "index",
  layout: 'clientLayout',
  mixins: [isMob576],
  components: {Advertisement, ClientHead, RedSection, RedHeadBox, CheckBox, VueSlickCarousel, BlogPost, RedSearchNow, BreedingRhombusSpinner, Paginate, StarRating, CtaSteps},

  async mounted() {
    const page = this.$route.query.page || 1;
    try {
      const [postsResponse, popularPostsResponse, mainPostsResponse, tagsResponse, categoriesResponse] = await Promise.all([
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/?page=${page}`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/popular`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/main`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tags`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/categories`),
      ]);

      this.postsData = postsResponse.data;
      this.popularPostsData = popularPostsResponse.data;
      this.mainPostsData = mainPostsResponse.data;
      this.tagsData = tagsResponse.data;
      this.categoriesData = categoriesResponse.data;
    } catch (error) {
      console.error('Error:', error);
    }
  },
  data() {
    return {
      postsData: null,
      popularPostsData: null,
      mainPostsData: null,
      tagsData: null,
      categoriesData: null,
      isAccepted: false,
      indexCanonical: 1,
      showMore: false,
      settings: {
        "dots": false,
        "arrows": false,
        "focusOnSelect": false,
        "infinite": true,
        "speed": 800,
        "slidesToShow": 3,
        "slidesToScroll": 1,

        "adaptiveHeight": true,
        "touchMove": false,
        "centerMode": false,
        "autoplay": true,
        "swipeToSlide": true,

      },
      settingsMob: {
        "dots": false,
        "arrows": false,
        "focusOnSelect": false,
        "infinite": true,
        "speed": 800,
        "slidesToShow": 1,
        "slidesToScroll": 1,

        "adaptiveHeight": true,
        "touchMove": true,
        "centerMode": false,
        "autoplay": true,
        "swipeToSlide": true,

      }
    }
  },

  methods: {
    accept() {
      this.isAccepted = !this.isAccepted
    },
    pageChange(index) {
      let self = this
      self.$router.push(index === 1 ? '/blog/' : `/blog/?page=${index}`);
      this.$axios
        .get(`${process.env.BLOG_API_BASE_URL}/api/posts/?page=${index}`)
        .then(response => {
          self.postsData = response.data
          self.indexCanonical = index
        })
        .catch(function (error) {
          console.log('error: ' + error);
        });
    },


    showNext() {
      this.$refs.carousel.next()
    },

    showPrev() {
      this.$refs.carousel.prev()
    },

    paginatePage(pageNum) {
      this.pageChange(pageNum)
      this.indexCanonical = pageNum
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  },

  computed: {

    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page) : 1
    },

    mounted() {
      this.isAccepted = false;
    }
  },

}
